const CommunicationHubRoutes = [
    {
        "url": "/communication-hub",
        "name": "appLayout.harriSH.communication-hub",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "platformPage": true,
        "component": "communicationHub",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.downgrade.module");
                }
            },
            { type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` }
        ],
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['hUser', '$state', 'TeamScheduleService', async (hUser, $state, TeamScheduleService) => {
                const isEmployer = hUser.isEmployer();
                if (!isEmployer) {
                    let activeBrand = await TeamScheduleService.getActiveBrand();
                    const isEmployeeCommsHubEnabled = await TeamScheduleService.isEmployeeBusinessHasCommsHubEnabled(activeBrand.business_id);
                    if (!isEmployeeCommsHubEnabled) {
                        $state.go("appLayout.schedule.team");
                    }
                }
            }],
        "onExit": ['commshubService', (commshubService) => {
                commshubService['triggerUnreadMessagesChanged']();
            }],
    },
    {
        "url": "/message?id=&brand_id=",
        "name": "appLayout.harriSH.communication-hub.message",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "newConversationComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ],
    },
    {
        "url": "/group",
        "name": "appLayout.harriSH.communication-hub.group",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "chCreateGroupContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/conversation/:id",
        "name": "appLayout.harriSH.communication-hub.conversation",
        "type": "frontend",
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "chConversation",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/direct-conversation/:id?message_id",
        "name": "appLayout.harriSH.communication-hub.direct-conversation",
        "type": "frontend",
        "platformPage": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "chDirectConversationContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/group-conversation/:id/:groupId?message_id",
        "name": "appLayout.harriSH.communication-hub.group-conversation",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "chGroupConversationContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/team",
        "name": "appLayout.harriSH.communication-hub.team",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "teamContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/files",
        "name": "appLayout.harriSH.communication-hub.files",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "filesContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/saved-messages",
        "name": "appLayout.harriSH.communication-hub.savedMessages",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "savedMessagesContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/deleted-messages",
        "name": "appLayout.harriSH.communication-hub.deletedMessages",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "deletedMessagesContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
    {
        "url": "/browse-groups",
        "name": "appLayout.harriSH.communication-hub.browseGroups",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "views": {
            "body": {
                "component": "chBrowseGroupsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['communication_hub', 'communication_hub_shared'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | CommsHub"
            }
        ]
    },
];
export function getCommunicationHubRoutes() {
    const communicationHubTeamRoutes = getCommunicationHubTLRoutes();
    return CommunicationHubRoutes.concat(communicationHubTeamRoutes);
}
export function getCommunicationHubTLRoutes() {
    const communicationHubTeamRoutes = [];
    for (let i = 0; i < CommunicationHubRoutes.length; i++) {
        const route = { ...CommunicationHubRoutes[i] };
        if (route.url === '/communication-hub') {
            delete route['component'];
            route["views"] = {
                "body": {
                    "component": "communicationHub"
                }
            };
        }
        route.url = route.url.replace('/', '/tl-');
        route.name = route.name.replace('appLayout.harriSH.', '');
        route.name = 'appLayout.schedule.tl-' + route.name;
        communicationHubTeamRoutes.push(route);
    }
    return communicationHubTeamRoutes;
}
//# sourceMappingURL=communication-hub.routes.js.map